@import "@/styles/variables";

.section {
	padding: 1.5rem;

	@media (max-width: 768px) {
		padding: 1rem;
	}
}

.header {
	margin-bottom: 1.5rem;
	flex-shrink: 0;
}

.title {
	font-size: 1.875rem;
	font-weight: 700;
	color: $gray-700;
	margin: 0 0 0.5rem 0;

	@media (max-width: 768px) {
		font-size: 1.5rem;
	}
}

.subtitle {
	font-size: 1rem;
	color: $gray-500;
	margin: 0;
}

.cardsGrid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 1.5rem;
	align-content: start;

	@media (max-width: 1200px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (max-width: 768px) {
		grid-template-columns: 1fr;
		gap: 1rem;
	}
}

.card {
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	padding: 1.5rem;
	background: #ffffff;
	border: 1px solid $gray-200;
	border-radius: $border-radius;
	transition: all 0.2s ease;
	cursor: pointer;
	text-align: left;
	min-height: 180px;

	@media (max-width: 768px) {
		min-height: 140px;
		padding: 1.25rem;
	}

	&:hover {
		border-color: $primary-color;
		box-shadow: 0 4px 12px rgba(127, 176, 47, 0.1);
		transform: translateY(-2px);

		.cardIconWrapper {
			background: $primary-color;
			color: #ffffff;
		}

		.cardArrow {
			transform: translateX(4px);
		}
	}

	&:active {
		transform: translateY(0);
	}
}

.cardIconWrapper {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 48px;
	height: 48px;
	background: $primary-light;
	border-radius: $border-radius;
	color: $primary-color;
	margin-bottom: 1rem;
	transition: all 0.2s ease;
}

.cardTitle {
	font-size: 1.125rem;
	font-weight: 600;
	color: $gray-700;
	margin: 0 0 0.5rem 0;
	line-height: 1.4;
}

.cardDescription {
	font-size: 0.875rem;
	color: $gray-500;
	margin: 0 0 auto 0;
	line-height: 1.5;
	flex: 1;
}

.cardBadge {
	display: inline-flex;
	align-items: center;
	padding: 0.25rem 0.75rem;
	background: $gray-100;
	border-radius: 1rem;
	font-size: 0.8125rem;
	font-weight: 500;
	color: $gray-500;
	margin-top: 1rem;
}

.cardArrow {
	position: absolute;
	top: 1.5rem;
	right: 1.5rem;
	color: $gray-400;
	transition: all 0.2s ease;
}
